/*=========================================================================================
  File Name: moduleScheduleMutations.js
  Description: Schedule Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_EVENT(state, event) {
		state.events.push(event);
	},
	SET_SCHEDULE_EVENTS(state, events) {
		// se crea propiedad calendarId ( init_hour + id ) local en la data para ser usada como
		// id de cada evento que se pinta en el calenadrio y se ordene por este valor
		state.events = events.map((e) => {
			return {...e, calendarId: e.init_hour + e.id};
		});
	},
	SET_SCHEDULE_LABELS_STATUS(state, labels) {
		state.eventSatusLabels = labels;
	},
	UPDATE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		// se crea propiedad nueva propiedad calendarId para que se actualice en el state
		// Se modifica el stado de la visita para que cambie el color en el calendar
		Object.assign(state.events[eventIndex], {
			...event,
			calendarId: event.init_hour + event.event_id,
			status_id: 5,
		});
	},
	REMOVE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		state.events.splice(eventIndex, 1);
	},
	CLEAN_EVENTS(state) {
		state.events = [];
	},
};
